<template>
  <div class="login-super-container">
	 <CreateNavBar />

    <div class="container">
      <loader :isLoading="isRequestInProgress"/>
      <h2 class="hero" id>Forgot Password</h2>

      <div class="login-form" v-if="!success">
        <form @submit.prevent="submit" novalidate>

          <InputComponent
            type="email"
            for="email"
            label_text="Email Address"
            attribute="Email Address"
            placeholder="you@awesome.com"
            v-model="form.email_address"
            :v="$v.form.email_address"
          />
          <div class="text-center">
            <button type="submit" class="btn btn-primary">Submit</button>
          </div>
        </form>
      </div>

      <div class="text-center" v-else>
        <small data-type="message" class="form-text error-message" v-if="fetchError">
          You're email isn't in our record, check your email address and try again.
        </small>
        <br/><br/>
        <small data-type="message" class="form-text" v-if="responseMessage">
          {{ responseMessage }}
        </small>
        <br/>
      </div>
    </div>

    <footer-view/>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { FORGOT_PASSWORD } from '@/store/types/actions.type'

import { required, email } from 'vuelidate/lib/validators'

import CreateNavBar from '@/components/common/CreateNavBar'
import Footer from '@/components/common/Footer'
import Loader from '@/components/common/Loader'
import InputComponent from '@/components/form/InputComponent'

export default {
  components: {
    CreateNavBar,
    InputComponent,
    Loader,
    'footer-view': Footer
  },
  data() {
    return {
      form: {
        email_address: ''
      },
      responseMessage: '',
      success: false
    }
  },
  validations: {
    form: {
      email_address: { required, email }
    }
  },
  computed: {
    ...mapGetters(['fetchError', 'isRequestInProgress'])
  },
  methods: {
    submit() {
      this.error = {}

      this.request_in_progress = true
      this.$v.form.$touch()
      if (!this.$v.form.$invalid) {
        this.postFields()
      }
    },
    postFields() {
      const self = this
      var fields = { ...this.form }

      this.$store.dispatch(FORGOT_PASSWORD, fields)
      .then(data => {
        self.responseMessage  = data.message
        self.success = true
      })
      .catch(err => { self.error.message = err })
    }
  }
}
</script>

<style scoped>
.container {
  box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.1);
  margin-top: 5em;
  padding: 48px;
  border-radius: 4px;
  width: 500px;
  background: white;
  margin-bottom: 64px;
}
.login-form {
  text-align: left;
  margin-top: 36px;
}
.login-form input {
  margin: 0 auto;
}
.login-form .form-group:first-child {
  margin-top: 0;
}
.login-super-container {
  background: #f2f9ff !important;
}

@media (min-width: 650px) and (max-width: 768px) {
  .container {
    box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.1);
    margin-top: 5em;
    padding: 35px;
    border-radius: 4px;
    width: 60%;
    background: white;
    margin-bottom: 64px;
  }

  h2 {
    font-size: 45px;
  }
}

@media (min-width: 480px) and (max-width: 649px) {
  .container {
    box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.1);
    margin-top: 5em;
    padding: 35px;
    border-radius: 4px;
    width: 70%;
    background: white;
    margin-bottom: 64px;
  }

  h2 {
    font-size: 35px;
  }

  input {
    padding-top: 25px;
    padding-bottom: 25px;
  }
}

@media (max-width: 479px) {
  .nav-container {
    padding-left: 15px;
  }

  .container {
    box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.1);
    margin-top: 5em;
    padding: 25px;
    border-radius: 4px;
    width: 85%;
    background: white;
    margin-bottom: 64px;
  }

  h2 {
    font-size: 30px;
  }

  input {
    padding-top: 25px;
    padding-bottom: 25px;
  }
}
</style>



// WEBPACK FOOTER //
// src/containers/ForgotPassword.vue